if (typeof JW === 'undefined') JW = {};
JW.AjxFrm = function ($, af)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'AJXFRM';
    _pri.opts = {

        dbg_lvl:    1,
        dlm:        ',',    // value delimiter
        enc:        false   // urlencode values
    };

    _pri.uid    = '';
    _pri.inited = false;
    _pri.page   = null;
    _pri.clsacc = null;

    _pri.$frm   = $(af);
    _pri.$xch   = null;

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    _pri.init = function()
    {
        _pri.dbgG('*** init()', _pri.cname);

        if (_pri.inited)
        {
            _pri.dbg('!!! already inited!');
            return;
        }

        if (_pri.$frm.length == 0)
        {
            _pri.dbg('    no form - exit');
            _pri.$frm = null;
            return;
        }

        _pri.inited = true;
        _pri.page = JW.Page;
        _pri.uid = JW.Page.getUId();

        _pri.initForm();
        _pri.$xch = $('#xch');
    };

    _pri.initForm = function()
    {
        _pri.$frm.submit(function(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        });

        if (typeof _pri.$frm.data('dlm') === 'string')
        {
            _pri.opts.dlm = _pri.$frm.data('dlm');
            _pri.dbgB('    got dlm: string: ', _pri.opts.dlm);
        }

        if (typeof _pri.$frm.data('enc') === 'boolean')
        {
            _pri.opts.enc = _pri.$frm.data('enc');
            _pri.dbgB('    got enc: boolean: ', _pri.opts.enc);
        }

        _pri.$frm.on('click', '[data-type="sub"]', _pri.formSubmit);
        _pri.$frm.on('ev_form_submit', function(e) {
            _pri.dbg('*** custom event ev_form_submit triggered');
            _pri.formSubmit();
        });

        var $acc = _pri.$frm.find('.acc-cls');
        if (1 == $acc.length)
        {
            _pri.clsacc = JW.ClsAcc(jQuery, $acc[0]);
        }
        else
        {
            _pri.dbg('    no acc-cls');
        }

        _pri.initAddSections();

        if (_pri.$frm.hasClass('mapform'))
        {
            _pri.mapfrm = JW.Mapform(jQuery, _pri.$frm[0]);
        }
    };

    _pri.initAddSections = function()
    {
        _pri.dbgG('*** initAddSections()');

        var $btns = $('[data-tpl][data-tgt]');
        $.each($btns, function(k, v) {
            _pri.dbg('... init ...');
            var $btn = $(v);
            $btn.on('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                _pri.dbg('*** insert section btn click');

                var cpx = JW.Page.getUId().toString(); // copy id
                var $tpl = $($btn.data('tpl')).clone();
                // var html = $tpl.prop('outerHTML');
                var html = $tpl.prop('outerHTML').replace(/\{CPX\}/g, '_' + cpx);
                $tpl = $(html);
                $tpl.prop('id', 'section_' + cpx);

                $($btn.data('tgt')).append($tpl[0]);

                var $div = $('#section_' + cpx);

                var $sels = $div.find('.jb-select');
                _pri.dbg('    $sels:', $sels);
                // var sel = JW.InpSelect(jQuery, $input[0]);
                $.each($sels, function(k, v) {
                    JW.InpSelect(jQuery, v);
                });

                $div.on('hidden.bs.collapse', function () {
                    $div.remove();
                });

                var $rem_btn = $div.find('.rem_section');
                $rem_btn.on('click', function() {
                    // $div.collapse('hide');
                    $div.remove();
                });


                $div.collapse('show');
                return false;
            });
        });


//         var $job_inps = $('#' + section + '_inps');
//         var inp_no = JW.Page.getUId().toString();
//         var job_url_arr_nm = section + 'urls';
//         var job_url_inp_id = section + 'url' + inp_no;
//         var job_pageid_arr_nm = section + 'pageids';
//         var job_pageid_sel_id = section + 'pageid' + inp_no;
//         _pri.dbg('inp_no: ', inp_no);
//
//         var $div = $("#sch-frm-tpl").clone(true);
//         //$div.removeAttr('id');
//         $div.prop('id', '{DIVIDNO}');
//         $div.removeClass('hidden');
//
//         var div = $div.prop('outerHTML');
//
//         //_pri.dbg('div: ', div);
//
//         div = $div.prop('outerHTML').replace(/\{JOBIDARRNO\}/g, section + 'ids')
//                     .replace(/\{JOBARRNO\}/g, section + 's')
//                     .replace(/\{DIVIDNO\}/g, 'divid' + inp_no)
//                     .replace(/\{JOBIDNO\}/g, section + 'id' + inp_no)
//                     .replace(/\{JOBNO\}/g, section + inp_no)
//                     .replace(/\{JOBURLARRNM\}/g, job_url_arr_nm)
//                     .replace(/\{JOBURLINPID\}/g, job_url_inp_id)
//                     .replace(/\{JOBPAGEIDARRNM\}/g, job_pageid_arr_nm)
//                     .replace(/\{JOBPAGEIDSELID\}/g, job_pageid_sel_id)
//                     ;
//
//         $div = $(div);
//
//         /*
//         var div = _pri.opts.tpls.add_job_inp
//                     .replace(/\{JOBIDARRNO\}/g, section + 'ids')
//                     .replace(/\{JOBARRNO\}/g, section + 's')
//                     .replace(/\{DIVIDNO\}/g, 'divid' + inp_no)
//                     .replace(/\{JOBIDNO\}/g, section+ 'id' + inp_no)
//                     .replace(/\{JOBNO\}/g, section + inp_no);
//
//         var $div = $(div);
//         */
//
//         $job_inps.append($div[0]);
//
//         _pri.dbg('******** job_pageid_sel_id: '+job_pageid_sel_id);
//         var $input = $('#divid' + inp_no).find('.jb-select.page-id'); //$div.find('.jb-select.page-id');
//         _pri.dbg('$input:', $input);
//         var sel = JW.InpSelect(jQuery, $input[0]);
// //                 $.each($input, function(k, v) {
// //                     //_pri.dbg(k);
// //                     //_pri.dbg(v);
// //                     JW.InpSelect(jQuery, v);
// //                 });
//
//         JW.TATextInput(jQuery, $div.find('#' + section + inp_no)[0]);
//
//         $div.find('button').on('click', function(e) {
//             _pri.dbg('button click - remove #divid' + inp_no);
//             $('#divid' + inp_no).remove();
//         });
//
//         $div.find('#' + job_url_inp_id).on('change', function(e) {
//             _pri.dbg('******** url inp change');
//             var $url_inp = $(this);
//             var $sel = $input.find('select');
//             _pri.dbg('$input.val(): ', $sel.val());
//             if ($url_inp.val() != '' && $sel.val() != '')
//             {
//                 $sel.find('option').prop("selected", false);
//                 $sel.change();
//             }
//         });
//
//         sel.on('inpselect:val_changed', function(e) {
//             _pri.dbg('******** XXXXXXXXXXXXXXXXXX sel on inpselect:val_changed');
//             var $sel = $input.find('select');
//             var $url_inp = $div.find('#' + job_url_inp_id);
//             _pri.dbg('$input.val(): ', $sel.val());
//             if ($url_inp.val() != '' && $sel.val() != '')
//             {
//                 $url_inp.val('');
//             }
//         });
    };

    _pri.formSubmit = function(e)
    {
        // _pri.dbg('typeof e: ', (typeof e));
        if (typeof e === 'object')
        {
            e.stopPropagation();
            e.preventDefault();
        }

        _pri.dbg('******** formSubmit() e: ', e);

        var win = _pri.$frm.attr('action');
        var form_data = _pri.getFormData(win);

        form_data.dataType = 'json';

        if (_pri.isObj(e))
        {
            var k = e.currentTarget.name;
            if (typeof form_data[k] === 'undefined')
            {
                form_data[k] = e.currentTarget.value;
            }
            else
            {
                _pri.dbg('!!! form_data key: ' + k + ' was already defined!?');
            }
        }

        _pri.dbg(form_data);
        // $('.frm-msgs').html('');
        // $('.frm-msgs').removeClass('show');

        // JW.Modal.get(win, form_data, _pri.onSubmitResponse);
        JW.Modal.get(win, form_data, JW.Modal.handleJSONRet);

        return false;
    };

    _pri.getFormData = function(win)
    {
        _pri.dbg('******** getFormData()');

        var form_data = {};

        var incfa = [];
        var excfa = [];
        var incf  = _pri.$frm.data('incf');
        if (typeof incf !== 'undefined' && incf != '')
        {
            incfa = incf.split(',');
        }
        else
        {
            var excf = _pri.$frm.data('excf');
            if (typeof excf !== 'undefined' && excf != '')
            {
                excfa = excf.split(',');
            }
        }
        _pri.setDataAttr(_pri.$frm, 'incf', '');
        _pri.setDataAttr(_pri.$frm, 'excf', '');

        switch (win)
        {
            default:
                //_pri.dbg(_pri.$frm.serialize());
                //_pri.dbg(_pri.$frm.serializeArray());

                var arr = _pri.$frm.serializeArray();
                var len = arr.length;
                var i, o, val;
                for (i = 0; i < len; ++i)
                {
                    o = arr[i];

                    if (incfa.length > 0 && incfa.indexOf(o.name) == -1)
                    {
                        continue;
                    }
                    else if (excfa.length > 0 && excfa.indexOf(o.name) != -1)
                    {
                        continue;
                    }

                    if (!_pri.opts.enc)
                    {
                        val = o.value.toString();
                    }
                    else
                    {
                        // val = encodeURIComponent(o.value.toString());
                        val = _pri.rawurlencode(o.value.toString());
                    }

                    if (!form_data.hasOwnProperty(o.name))
                    {
                        form_data[o.name] = val;
                    }
                    else
                    {
                        form_data[o.name] += _pri.opts.dlm + val;
                    }
                }

                if (_pri.clsacc != null)
                {
                    _pri.dbg('    get clsacc');
                    var fd = _pri.clsacc.getFormData();
                    for (var p in fd)
                    {
                        if (!fd.hasOwnProperty(p))
                        {
                            continue;
                        }

                        form_data[p] = fd[p];
                    }
                }
            break;
        }

        return form_data;
    };

    _pri.extend();
    _pri.init();
    // expose public methods
    return publ;
};